import React from 'react';
import { useTranslation } from 'react-i18next';
import { useForm, useFormState } from 'react-final-form';
import { FiltersSection } from './FiltersSection';
import { Chips } from '../../../ui/Chips';
import { chipsStyles, FiltersOptionsWrapper } from './styled';

const buildingType = [
  {
    value: 'BUSINESS_CENTER',
    id: 'new-search-form-business-center',
    name: 'search.form.building_type_group.business'
  },
  {
    value: 'APARTMENT',
    id: 'new-search-form-house-flat',
    name: 'search.form.building_type_group.apartment'
  },
  {
    value: 'VILLA',
    id: 'new-search-form-villa-building',
    name: 'search.form.building_type_group.villa'
  }
];

export const NewSearchBuildingType = () => {
  const { t } = useTranslation();
  const { values } = useFormState();
  const { change } = useForm();

  const handleOptionChange = (id: string) => {
    const normalizedBuildingType =
      values.building_type === 'undefined' || !values.building_type
        ? []
        : values.building_type;

    const updatedValue = normalizedBuildingType.includes(id)
      ? normalizedBuildingType.filter((value: string) => value !== id)
      : [...normalizedBuildingType, id];

    change('building_type', updatedValue);
  };

  return (
    <FiltersSection title={t('search.form.building_type_group.title')}>
      <FiltersOptionsWrapper>
        {buildingType.map(building => (
          <Chips
            text={t(building.name)}
            value={building.value}
            type="checkbox"
            hasCustomOnChange
            key={building.id}
            storedValue={values.building_type}
            onClick={() => handleOptionChange(building.value)}
            styles={chipsStyles}
            stat={building.id}
          />
        ))}
      </FiltersOptionsWrapper>
    </FiltersSection>
  );
};
